export function initDevScheme() {
  if (document.documentElement.dataset.webtenseDevSchemeInit) {
    return;
  }

  document.documentElement.dataset.webtenseDevSchemeInit = 'true';
  document.querySelectorAll('.dev-scheme__hint').forEach((hint) => {
    const content = hint.nextElementSibling;
    hint.addEventListener('mouseenter', () => {
      content?.classList.add('active');
    });
    hint.addEventListener('mouseleave', () => {
      content?.classList.remove('active');
    });
  });
}
